import { Button } from "../ui/button";
import { useNativePlatform } from "@/hooks/useNativePlatform";
import { NativeOverlaySheet } from "@/components/native/NativeOverlaySheet";

export const DescriptionPopup = ({
  description,
  title,
  onClose,
}: {
  description: string;
  title: string;
  onClose: () => void;
}) => {
  const { isNative } = useNativePlatform();

  if (isNative) {
    return (
      <NativeOverlaySheet open={true} title={title} onOpenChange={(o) => !o && onClose()}>
        <p className="text-sm leading-relaxed whitespace-pre-wrap">{description}</p>
      </NativeOverlaySheet>
    );
  }

  return (
    <div
      className="fixed inset-0 bg-black/40 flex items-center justify-center z-50 p-4"
      onClick={onClose}
    >
      <div
        className="p-4 rounded-lg max-w-2xl w-[70%] bg-card border border-primary/40"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex flex-row justify-between">
          <h2 className="text-lg font-bold mb-4">{title}</h2>
          <Button variant="ghostNoHover" onClick={onClose} className="-m-4">
            X
          </Button>
        </div>
        <p className="text-sm leading-relaxed whitespace-pre-wrap">{description}</p>
      </div>
    </div>
  );
};
